// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__1NbRW","stars":"styles_stars__2dh6m","mountains":"styles_mountains__10ASp","road":"styles_road__1K3-M"};